<template>
  <label class="terms-block">
    <Checkbox v-model="terms" :required="required" />
    <span>
      {{ $t('auth-terms.agree.label') }}
      <a href="/user_agreement.pdf" target="_blank"> {{ $t('auth-terms.agree.value') }}</a>
      {{ $t('auth-terms.agree.and') }}
      <a href="/pd_policy.pdf" target="_blank">{{ $t('auth-terms.privacy') }}</a>
    </span>
  </label>
</template>

<script>
import Checkbox from '@/components/form/Checkbox'
export default {
  name: 'terms',
  components: { Checkbox },
  inheritAttrs: false,
  props: {
    required: Boolean,
  },
  computed: {
    terms: {
      get() {
        return !!localStorage.getItem('terms-auth')
      },
      set(v) {
        if (v) {
          localStorage.setItem('terms-auth', 'yes')
        } else {
          localStorage.removeItem('terms-auth')
        }
      },
    },
  },
}
</script>

<style lang="scss">
.terms-block {
  display: flex;
  align-items: center;
  color: $darkGrey;
  margin: 0;

  .checkbox input {
    margin-bottom: 0;
  }

  a {
    color: inherit;
    text-decoration: none;
    transition: all 0.25s;

    &:hover {
      border-bottom: 1px dashed $darkGrey;
    }
  }
}
</style>
